export const mockExtraModelDataHora = {
  dataApreensao: null,
  horaApreensao: null,
  dataRemocao: null,
  horaRemocao: null
}



// WEBPACK FOOTER //
// ./src/domain/grv/helpers/grv-mock.js